import React, { useContext, useEffect, useState } from 'react';
import styles from './SearchBar.module.scss';
import SearchBarSpecialtySelect from './search-bar-specialty-select/SearchBarSpecialtySelect';
import SearchBarCriteriaInput from './search-bar-criteria-input/SearchBarCriteriaInput';
import SearchBarLocationInput from './search-bar-location-input/SearchBarLocationInput';
import SearchKeyWordInput from './search-bar-key-word-input/SearchBarKeyWordInput';
import SearchBarButton from './search-bar-button/SearchBarButton';
import { AppContext } from '../../context/AppContext';
import { DirectoryListType } from '../directory-list/DirectoryList';
import { getCategoriesToMap } from '../../lib/util';
import SearchBarDistanceSelect from './search-bar-distance-select/SearchBarDistanceSelect';
import { defaultAppState } from '../../context/DefaultAppState';

const SearchBar = (props: any) => {
  const appContext = useContext(AppContext);

  useEffect(() => {
    
  }, [appContext.search])

  return (
    <>
      {appContext.isDirectorySelected && appContext.directoryListType !== DirectoryListType.none && appContext.directoryListType !== DirectoryListType.all ? (
        <div className={styles.searchBar}>
          <SearchBarSpecialtySelect />
          <SearchBarCriteriaInput />
          <SearchBarLocationInput/>
          <SearchBarDistanceSelect />
          <SearchBarButton />
        </div>
      ) : null}
      {/* {appContext.isDirectorySelected && appContext.directoryListType !== DirectoryListType.none && appContext.directoryListType !== DirectoryListType.all && appContext.origin !== defaultAppState.origin ? (
        <div className={styles.locationSearchBar}>
          <SearchBarSpecialtySelect />
          <SearchBarCriteriaInput />
          <SearchBarLocationInput />
          <SearchBarDistanceSelect />
          <SearchBarButton />
        </div>
      ) : null} */}
      {appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.all ? (
        <div className={styles.keywordSearchBar}>
          <SearchKeyWordInput />
          <SearchBarButton />
        </div>
      ) : null}
    </>
  );
};

export default SearchBar;
